import React, { createRef, useEffect, useState, useRef} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useHistory } from "react-router-dom";
import FileCopySharpIcon from '@material-ui/icons/FileCopySharp';
import { Grid, IconButton, Typography } from "@material-ui/core";
import CircularProgress from '@material-ui/core/CircularProgress';
import { createFileName, useScreenshot } from "use-react-screenshot";
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

const useStyles = makeStyles( ( theme ) => ( {
    root: {
        // border: '1px solid #f0aa08',
        border: `1px solid ${theme.palette.primary.main}`,
        backgroundColor: '#000000',
        color: `${theme.palette.primary.main}`,
        justifyContent: 'center',
        width: '100%',
        alignContent: "baseline"
    },
    rootNoBorder: {
        backgroundColor: '#000000',
        color: `${theme.palette.primary.main}`,
        justifyContent: 'center',
        width: '100%'
    },
    rootBg: {
        border: `1px solid ${theme.palette.primary.main}`,
        backgroundColor: '#000000',
        color: `${theme.palette.primary.main}`,
        justifyContent: 'center',
        alignItems: 'center',
        alignContent: 'space-between'
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        margin: 'auto',
        width: 'fit-content',
    },
    formControl: {
        marginTop: theme.spacing( 2 ),
        minWidth: 120,
    },
    formControlLabel: {
        marginTop: theme.spacing( 1 ),
    },
    table: {
        minWidth: 350,
    },
} ) );

export default function ConfirmRegisterDialog ( props ) {
    const { openDialog, onLoading, registerConfirmData } = props
    const classes = useStyles();
    const [ open, setOpen ] = React.useState( openDialog );
    const [ loading, setLoading ] = useState( onLoading )
    const [ fullWidth, ] = React.useState( true );
    const [ maxWidth, ] = React.useState( 'md' );
    const [ registerConfirm, setRegisterConfirm ] = React.useState( {
        user_id: 'ufyu9999999',
        password: 'aa0999999999'
    } )

    const ref = createRef( null );
    // const [ , takeScreenShot ] = useScreenshot( {
    //     type: "image/jpeg",
    //     quality: 1.0,
    //     width: '650px',
    //     height: '650px'
    // } );

    const [image, takeScreenshot] = useScreenshot()

    const getImage = () => {
        // console.log("REF CURRENT :", ref.current)
        if (loading){
            return
        }
        takeScreenshot( ref.current );
        downloadScreenshot();
    }
    const download = ( image, { name = "img" } = {} ) => {
        const a = document.createElement( "a" );
        a.href = image;
        a.download = createFileName( registerConfirm.user_id );
        a.click();
        //handleClose()
    };

    const downloadScreenshot = () => takeScreenshot( ref.current ).then( download );
    let history = useHistory()

    const handleClose = () => {
        setOpen( false );
        history.push( "/login" )
    };

    useEffect( () => {
        setOpen( openDialog )
        setLoading( onLoading )
        //getImage()
    }, [ openDialog, onLoading ] )

    useEffect( () => {
        // console.log( "registerConfirmData: ", registerConfirmData )
        if ( registerConfirmData.user_id == null ) {
            return
        }
        setRegisterConfirm( {
            ...registerConfirm,
            user_id: registerConfirmData.user_id,
            password: registerConfirmData.password
        } )
    }, [ registerConfirmData ] )

    return (
        // <React.Fragment>
            <Dialog
                fullWidth={fullWidth}
                maxWidth={maxWidth}
                open={open}
                onClose={handleClose}
                aria-labelledby="max-width-dialog-title"
                // disableBackdropClick={true}
                ref={ref}
            >
                {
                    (image === null)?
                        (
                            <div onClick={getImage}>
                            <DialogTitle className={classes.rootBg}>
                            <Grid container
                                  direction="column"
                                  justifyContent="center"
                                  alignItems="center">
                                <div>ผลการสมัครสมาชิก</div>
                                <div>{window.location.hostname}</div>
                            </Grid>
                        </DialogTitle>
                        <DialogContent className={classes.root}>
                            <DialogContentText className={classes.rootNoBorder} align={"center"}>
                                {
                                    ( loading ) ?
                                        ( <CircularProgress/> ) :
                                        (
                                            <>
                                                {/*<Typography color={"secondary"}><b>*กรุณาแตะหน้าจอเพื่อ Save </b></Typography>*/}
                                                <Typography variant={"h6"}
                                                            align={"center"}><AccountCircleIcon/>
                                                    <b>{registerConfirm.user_id}</b>
                                                    {/*<IconButton onClick={()=>alert('username')} color={'primary'}>*/}
                                                    {/*<FileCopySharpIcon fontSize={"small"} />*/}
                                                    {/*</IconButton>*/}
                                                </Typography>
                                                <Typography variant={"h6"} align={"center"} color={"secondary"}><VpnKeyIcon/>
                                                    <b>{registerConfirm.password}</b>
                                                    {/*<IconButton onClick={() => alert( 'password' )} color={'secondary'}>*/}
                                                    {/*    <FileCopySharpIcon fontSize={"small"}/>*/}
                                                    {/*</IconButton>*/}
                                                </Typography>
                                                <Button variant={"contained"} color={"primary"} onClick={()=>getImage()}>กดเพื่อบันทึกข้อมูลการสมัคร</Button>
                                            </>
                                        )
                                }
                            </DialogContentText>
                        </DialogContent>
                    {/*<DialogActions className={classes.root}>*/}
                    {/*<Button*/}
                    {/*//onClick={handleClose}*/}
                    {/*// startIcon={<CloudDownloadIcon/>}*/}
                    {/*onClick={getImage}*/}
                    {/*variant={'contained'}*/}
                    {/*color="primary">*/}
                    {/*กดเพื่อ Save ข้อมูล*/}
                    {/*</Button>*/}
                    {/*</DialogActions>*/}
                    </div>):
                        (<img height={"850"} width={"1000"} src={image} alt={"ScreenShot"} />)
                }
            </Dialog>
        // </React.Fragment>
    );
}
